import React from "react";
import TemplateProvider from "./offer-templates/TemplateProvider";
import {
  TemplateId,
  PublicOfferData,
  BrandKit,
  TermsAndConditions,
} from "./offer-templates/BaseTemplate";

interface PublicOfferPreviewProps {
  offer: PublicOfferData;
  brandKit?: BrandKit;
  termsAndConditions?: TermsAndConditions;
  templateId?: TemplateId;
  editMode?: boolean;
  onColorChange?: (colorType: string, color: string) => void;
  showColorPicker?: string | null;
  setShowColorPicker?: (colorType: string | null) => void;
  onHeroUpload?: (file: File) => void;
  onHeroRemove?: () => void;
  uploadingHero?: boolean;
  onTermsToggle?: (enabled: boolean) => void;
  onTermsContentChange?: (content: string) => void;
}

const PublicOfferPreview: React.FC<PublicOfferPreviewProps> = ({
  offer,
  brandKit,
  termsAndConditions,
  templateId,
  editMode = false,
  onColorChange,
  showColorPicker,
  setShowColorPicker,
  onHeroUpload,
  onHeroRemove,
  uploadingHero = false,
  onTermsToggle,
  onTermsContentChange,
}) => {
  // Use templateId from props, brandKit, or fallback to "modern"
  const activeTemplateId = templateId || brandKit?.templateId || "modern";

  return (
    <TemplateProvider
      offer={offer}
      brandKit={brandKit}
      termsAndConditions={termsAndConditions}
      templateId={activeTemplateId}
      editMode={editMode}
      onColorChange={onColorChange}
      showColorPicker={showColorPicker}
      setShowColorPicker={setShowColorPicker}
      onHeroUpload={onHeroUpload}
      onHeroRemove={onHeroRemove}
      uploadingHero={uploadingHero}
      onTermsToggle={onTermsToggle}
      onTermsContentChange={onTermsContentChange}
    />
  );
};

export default PublicOfferPreview;
